const apiHost = window.location.hostname || 'localhost';
//export const url = `${window.location.protocol}//${apiHost}:3008`
//export const url ='https://este.virsbet.com' 
export const url = apiHost === 'localhost'
    ? (process.env.REACT_APP_API_URL || `${window.location.protocol}//${apiHost}:3008`)
    : window.location.origin;
// Las cookies de sesión deben acompañar todas las solicitudes al API,
// incluso cuando la interfaz y el servidor están en subdominios distintos.
if (!window.__dogs8CredentialFetch) {
    const browserFetch = window.fetch.bind(window);
    const recentTicketRequests = new Map();
    const pendingRepeatRequests = new Map();
    const createIdempotencyKey = () => window.crypto?.randomUUID?.()
        || `${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}-${Math.random().toString(36).slice(2)}`;
    window.fetch = (input, options = {}) => {
        let requestOptions = { ...options, credentials: options.credentials || 'include' };
        try {
            const method = String(options.method || input?.method || 'GET').toUpperCase();
            const rawUrl = typeof input === 'string' ? input : input?.url;
            const path = new URL(rawUrl, window.location.href).pathname.replace(/\/+$/g, '');
            const body = typeof options.body === 'string' ? options.body : '';
            const parsedBody = body ? JSON.parse(body) : null;
            const isRepeat = method === 'POST'
                && path === '/ticket/pay'
                && String(parsedBody?.action || '').toLowerCase().includes('repeat');
            if (isRepeat) {
                const signature = `${rawUrl}\n${body}`;
                if (pendingRepeatRequests.has(signature)) {
                    return Promise.resolve(new Response(JSON.stringify('Solicitud de repetición ya en proceso'), {
                        status: 200,
                        headers: { 'content-type': 'application/json' }
                    }));
                }
                const requestHeaders = new Headers(options.headers || input?.headers || {});
                if (!requestHeaders.has('x-idempotency-key')) requestHeaders.set('x-idempotency-key', createIdempotencyKey());
                requestOptions = { ...requestOptions, headers: requestHeaders };
                pendingRepeatRequests.set(signature, true);
                return browserFetch(input, requestOptions).finally(() => pendingRepeatRequests.delete(signature));
            }
            if (method === 'POST' && path === '/ticket' && typeof options.body === 'string') {
                const signature = `${rawUrl}\n${options.body}`;
                const now = Date.now();
                let entry = recentTicketRequests.get(signature);
                if (!entry || now - entry.at > 3000) {
                    entry = { at: now, key: createIdempotencyKey() };
                    recentTicketRequests.set(signature, entry);
                    window.setTimeout(() => {
                        if (recentTicketRequests.get(signature) === entry) recentTicketRequests.delete(signature);
                    }, 10000);
                }
                const requestHeaders = new Headers(options.headers || input?.headers || {});
                if (!requestHeaders.has('x-idempotency-key')) requestHeaders.set('x-idempotency-key', entry.key);
                requestOptions = { ...requestOptions, headers: requestHeaders };
            }
        } catch (_) {}
        return browserFetch(input, requestOptions);
    };
    window.__dogs8CredentialFetch = true;
}


export const headers = {
    'content-type': 'application/json',
    get authorization() {
        return localStorage.getItem('sessionId') || '';
    }
}

export const widthCanvas=window.innerWidth*0.99
export const heightCanvas=window.innerHeight*0.99

export const sizeRef = ()=>{
    const w = widthCanvas;
    const h = heightCanvas;
    return(w<h? w:h)
}

export const lang = 'EN' // 'ES', 'IT', 'PO'
